document.addEventListener("DOMContentLoaded", () => {

  const steps =
    document.querySelectorAll(".builder-step");

  let currentStep = 0;

  const nextBtn =
    document.getElementById("builder-next");

  const prevBtn =
    document.getElementById("builder-prev");

  function showStep(index){

    steps.forEach(step =>
      step.classList.remove("active")
    );

    steps[index].classList.add("active");

    if(prevBtn){
      prevBtn.style.display =
        index === 0 ? "none" : "block";
    }

    if(nextBtn){
      nextBtn.innerText =
        index === steps.length - 1
          ? "Done"
          : "Continue";
    }

  }

  nextBtn?.addEventListener("click", () => {

    if(currentStep < steps.length - 1){

      currentStep++;

      showStep(currentStep);

    }

  });

  prevBtn?.addEventListener("click", () => {

    if(currentStep > 0){

      currentStep--;

      showStep(currentStep);

    }

  });

  showStep(0);

});